import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";

const PaymentFailure = () => {
  return (
    <div className="mx-auto p-2">
      <div className="max-w-[800px] flex flex-col items-center justify-center p-6 bg-red-50 border border-red-200 rounded-2xl shadow-sm">
        <ExclamationTriangleIcon className="size-20 text-red-500 mb-4" />
        <h2 className="text-lg font-semibold text-red-700">Payment Failed</h2>
        <p className="text-lg text-red-600 mt-2 text-center">
          We regret to inform you that your payment for the training session was
          unsuccessful.
        </p>
        <p className="text-lg text-red-600 mt-2 text-center">
          To complete your registration, please attempt the payment again
        </p>
        <div className="text-sm text-red-600 text-center mt-8">
          <p className="my-4">
            If you have already been charged or require any assistance, please
            contact our support team at the contact details mentioned below.
            Thank you for your cooperation. We look forward to having you in the
            training.
          </p>
          <p>Best regards,</p>
          <p>National Healthcare & Wellness Mission</p>
          <p>Contact Number: +913614516663, +919707076232, +919707998887</p>
          <p>Email: nhwm.info@gmail.com</p>
        </div>
        <div className="flex items-center justify-center my-6">
          <Link to="/training-registration" className="w-[200px]">
            <div className="w-[200px] px-4 py-2 rounded-md bg-red-300 border border-red-500 text-lg font-semibold text-center text-white hover:bg-red-400">
              Resubmit Form
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
